import React from 'react';
import { Text, Tooltip } from '@wix/wix-base-ui';

import * as symbols from '@wix/santa-editor-symbols';

import { translate } from '#packages/i18n';

import styles from './newWorkspaceContentHeader.scss';

interface AddPageEntryButtonProps {
  tooltipContent: string;
  addButtonLabel?: string;
  onClick?: () => void;
}

const AddPageEntryButton: React.FC<AddPageEntryButtonProps> = ({
  tooltipContent,
  addButtonLabel,
  onClick,
}) => (
  <Tooltip
    content={tooltipContent}
    shouldTranslate={false}
    dataHook="add-page-button"
  >
    <span onClick={onClick} className={styles.addPage}>
      <symbols.symbol name="addPage" />
      {addButtonLabel ?? translate('Pages_Menu_Add_Button_Label')}
    </span>
  </Tooltip>
);

interface NewWorkspaceContentHeaderProps {
  showAddOptions: boolean;
  title: string;
  tooltipContent?: string;
  addButtonLabel?: string;
  onAddPage?: () => void;
}

/*
 * Custom header for pages panel content for the new workspace
 */
export const NewWorkspaceContentHeader: React.FunctionComponent<
  NewWorkspaceContentHeaderProps
> = ({ title, showAddOptions, tooltipContent, addButtonLabel, onAddPage }) => {
  return (
    <div className={styles.root}>
      <Text size="small" shouldTranslate={false}>
        {title}
      </Text>
      {showAddOptions && (
        <AddPageEntryButton
          tooltipContent={tooltipContent}
          addButtonLabel={addButtonLabel}
          onClick={onAddPage}
        />
      )}
    </div>
  );
};
